var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search",
      class: { "search_size-small": _vm.size === "small" },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.value,
            expression: "value",
            modifiers: { trim: true },
          },
        ],
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.value },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.searchHandle.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.value = $event.target.value.trim()
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.searchHandle.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/icons/i_search.svg"),
              alt: "search",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }